const headerDatas = [
  {
    prop: "InvAddCode",
    label: "产品代码",
    columnwidth: 117,
  },
  {
    prop: "InvName",
    label: "产品名称",
    columnwidth: 133,
  },
  {
    prop: "Batch",
    label: "批号",
    columnwidth: 110,
  },
  {
    prop: "ValiDate",
    label: "有效期",
    columnwidth: 102,
  },
  {
    prop: "Quantity",
    label: "上架数量",
    columnwidth: 82,
  },
  {
    prop: "UnitPrice",
    label: "含单价",
    columnwidth: 105,
  },
  {
    prop: "TaxUnitPriceSum",
    label: "价税合计",
    columnwidth: 110,
  },
];
export default headerDatas;
